// Write your code here
import './index.css'
import {Link} from 'react-router-dom'

const TeamCard = props => {
  const {details} = props
  const {name, teamImageUrl, id} = details

  return (
    <Link to={`/team-matches/${id}`} className="card_link">
      <li className="cards">
        <img className="teamlogo_image" src={teamImageUrl} alt={`${name}`} />
        <p className="teamName">{name}</p>
      </li>
    </Link>
  )
}
export default TeamCard
